import { computed, defineComponent } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import { formatMoneyString } from "@/lib/moneyHelpers";
import config from "@/config";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseForm from "@/components/BaseForm";
import BaseInput from "@/components/BaseInput";
import FormatMoney from "@/components/FormatMoney";

export default defineComponent({
  name: "CreatePayoutRequestModal",
  components: { BaseConfirm, BaseButton, BaseForm, BaseInput, FormatMoney },
  props: {
    show: { type: Boolean, required: true },
    loading: { type: Boolean, default: false },
    primaryBalance: { type: Number, required: true },
    value: { type: String, required: true },
    currencySymbol: { type: String, required: true },
    subText: { type: String, required: true },
    commission: { type: Number, required: true },
    hasError: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const onSubmit = async () => {
      emit("submit");
    };
    const hideModal = () => {
      emit("close");
    };

    const amount = computed(() => {
      const numberValue = Number(props.value);
      return isNaN(numberValue) ? 0 : numberValue;
    });

    const commissionText = computed(() => {
      return $t("Payout commissions and fees: {0}", [
        formatMoneyString(amount.value ? props.commission : 0, {
          minimumFractionDigits: config.EXTENDED_FRACTIONAL_PART_LENGTH,
        }),
      ]);
    });

    const requestButtonText = computed(() => {
      const payoutText = formatMoneyString(amount.value ? amount.value - props.commission : 0, {
        minimumFractionDigits: config.EXTENDED_FRACTIONAL_PART_LENGTH,
      });
      return amount.value ? $t("Request {0}", [payoutText]) : $t("Request");
    });

    return { onSubmit, hideModal, commissionText, requestButtonText };
  },
});
